<div class="form-field">
    <label *ngIf="label" [class.disabled]="disabled" class="form-label mb-1">{{label}}</label>
    <div>

        <nb-form-field >
            <input
                    style="text-align: {{align}}"
                    digitsOnly
                    [disabled]="disabled"
                    [appFocus]="focus"
                    (focus)="onFocusEvent()"
                    [fullWidth]="fullWidth"
                    [type]="type"
                    [(ngModel)]="value"
                    nbInput
                    [maxlength]="maxLength"
                    [placeholder]="placeholder"
                    [fieldSize]="size"
                    (input)="onInput()">
        </nb-form-field>

    </div>

    <div *ngIf="help" class="form-help">{{help}}</div>
</div>

